<template>
  <div class="login-wrapper">
    <div class="container-fluid bg">
      <div class="row justify-content-center align-items-center login overflow-scroll">

        <div class="smartphone-img">
          <img src="../assets/img/tel_appli.png" alt="smartphone-img" />
        </div>

        <div v-if="!isEntitiesPage" class="card border-0 mb-0 p-3">

          <!-- Header and logo -->
          <div class="card-header text-center p-t-0">
            <p v-if="!isSubmitted">
              {{ $t("SignUpForm.go_to_signin_begin") }}
              <span class="signin-link">
                <router-link :to="{ name: 'SignInForm' }">
                  {{ $t("SignUpForm.click_here") }}
                </router-link>
              </span>
              {{ $t("SignUpForm.go_to_signin_end") }}
            </p>

            <img class="logo-style img-fluid"
                 src="../assets/img/logo_connexion_ts.png"
                 alt="logo-black"
                 width="250"
                 height="43" />
          </div>
          <!-- End of header and logo -->

          <div class="card-body">
            <!-- Top of form -->
            <transition name="slide-fade">
              <div class="align-items-center card-description signup-success m-b-50"
                   v-show="isSubmitted">
                {{ $t("SignUpForm.formSubmitted") }}
              </div>
            </transition>

            <transition name="slide-fade">
              <div class="align-items-center card-description signup-success" v-show="isSended">
                {{ $t("SignUpForm.email_sended") }}
              </div>
            </transition>

            <transition name="slide-fade">
              <form v-show="!isSubmitted && !isSended"
                    @submit.prevent="signUp"
                    class="p-t-15"
                    role="form"
                    novalidate="novalidate">

                <div v-if="isUserExists">
                  <div v-if="isPending" class="box-message-pending">
                    <div>{{ $t("SignUpForm.email_unique_pending") }}</div>

                    <div>
                      <a href="#" v-on:click="sendMailCandidate">
                        {{ $t("SignUpForm.send_me_email") }}
                      </a>
                    </div>
                  </div>

                  <div v-else class="alert alert-danger">
                    <p v-html="$t('SignUpForm.email_unique_not_pending')"></p>
                  </div>
                </div>

                <transition name="slide-fade" v-else>
                  <div v-if="hasErrors" class="alert alert-danger">
                    <ul>
                      <li v-for="error in serverErrors">{{ error }}</li>
                    </ul>
                  </div>
                </transition>

                <div class="form-group form-group-default required">
                  <label>{{ $t("models.user.last_name") }}</label>
                  <div class="controls">
                    <input v-model="user.last_name"
                           v-validate="'required'"
                           type="text"
                           name="last_name"
                           class="form-control"
                           required=""
                           id="last_name"
                           aria-required="true" />
                  </div>
                </div>

                <transition name="slide-fade">
                  <label v-show="errors.has('last_name')"
                         id="last_name-error"
                         class="error"
                         for="last_name">
                    {{  errors.first('last_name') }}
                  </label>
                </transition>

                <div class="form-group form-group-default required m-t-20">
                  <label>{{ $t("models.user.first_name") }}</label>
                  <div class="controls">
                    <input v-model="user.first_name"
                           v-validate="'required'"
                           type="text"
                           name="first_name"
                           class="form-control"
                           required=""
                           id="first_name"
                           aria-required="true">
                  </div>
                </div>
                <transition name="slide-fade">
                  <label v-show="errors.has('first_name')"
                         id="first_name-error"
                         class="error"
                         for="first_name">
                    {{ errors.first('first_name') }}
                  </label>
                </transition>

                <div class="form-group form-group-default required m-t-20">
                  <label>{{ $t("models.user.email") }}</label>
                  <div class="controls">
                    <input v-model="user.email"
                           v-validate="'required|email'"
                           type="text"
                           name="email"
                           class="form-control"
                           required=""
                           id="email"
                           aria-required="true"
                           v-on:blur="validateStatusEmail()"
                           @input="handleEmailInput">
                  </div>
                </div>
                <div v-if="mailCheckedEmail" class='form--notice form--suggestEmail'>
                  {{ $t("models.user.error_email") }}<span @click="setEmail" class="email-suggestion">{{ mailCheckedEmail }}</span> ?
                </div>

                <div v-if="specialCharError" class='form--notice error'>
                  {{ $t("models.user.no_accents_error") }}
                </div>

                <transition name="slide-fade">
                  <label v-show="errors.has('email')"
                         id="email-error"
                         class="error"
                         for="email">
                    {{ errors.first('email') }}
                  </label>
                </transition>

                <div class="form-group form-group-default required m-t-20">
                  <label>{{ $t("models.user.mobile_phone") }}</label>
                  <div class="controls">
                    <input v-model="user.phone_display"
                           v-validate="'required|phone'"
                           type="tel"
                           name="mobile_phone"
                           class="form-control"
                           required=""
                           id="phone"
                           aria-required="true">
                  </div>
                </div>
                <transition name="slide-fade">
                  <label v-show="errors.has('mobile_phone')"
                         id="phone-error"
                         class="error"
                         for="phone">
                    {{ errors.first('mobile_phone') }}
                  </label>
                </transition>

                <div class="form-group form-group-default required m-t-20">
                  <label>{{ $t("models.user.password") }}</label>
                  <div class="controls">
                    <input v-model.lazy="user.password"
                           v-validate="'required|min:8'"
                           type="password"
                           class="form-control"
                           name="password"
                           required=""
                           id="password"
                           aria-required="true">
                  </div>
                </div>
                <transition name="slide-fade">
                  <label v-show="errors.has('password')"
                         id="password-error"
                         class="error"
                         for="password">
                    {{ errors.first('password') }}
                  </label>
                </transition>

                <div class="form-group form-group-default required m-t-20">
                  <label>{{ $t("models.user.confirm_password") }}</label>
                  <div class="controls">
                    <input v-model="password_confirmation"
                           v-validate="'required|confirmed:password'"
                           type="password"
                           class="form-control"
                           name="password_confirmation"
                           required=""
                           id="password_confirmation"
                           aria-required="true">
                  </div>
                </div>
                <transition name="slide-fade">
                  <label v-show="errors.has('password_confirmation')"
                         id="password_confirmation-error"
                         class="error"
                         for="password_confirmation">
                    {{ errors.first('password_confirmation') }}
                  </label>
                </transition>

                <div class="form-group form-group-default required m-t-20">
                  <label>{{ $t("models.user.entity_code") }}</label>
                  <div class="controls">
                    <input v-model="entityCode"
                           v-validate="`required|max:${maxEntityCodeSize}`"
                           type="entityCode"
                           class="form-control"
                           name="entityCode"
                           required=""
                           id="entityCode"
                           aria-required="true">
                  </div>
                </div>
                <transition name="slide-fade">
                  <label v-show="errors.has('entityCode')"
                         id="entityCode-error"
                         class="error"
                         for="entityCode">
                    {{ errors.first('entityCode') }}
                  </label>
                </transition>

                <profession-form v-if="entityCodeValidity"
                                 :data-user="userToAddon"
                                 :availableServices="servicesOptions"
                                 :availableHubs="hubsOptions"
                                 :availableOccupations="occupationsOptions"
                                 :is-manager="false"
                                 :collapseHubs="true"
                                 :small="true"
                                 @change="onProfessionFormChange" />

                <terms-and-conditions :currentUser="user" :currentEntity="currentEntity" />

                <div id="signup-submit-btn" class="row marge-mobile justify-content-between m-t-10 m-r-5 m-l-5" dir="rtl">
                  <button class="btn btn-primary p-b-5 m-b-10" type="submit">
                    {{ $t("SignUpForm.register") }}
                  </button>
                  <button v-show="showEntities"
                          type="button"
                          class="btn add-establishment-btn m-b-10"
                          @click="showEntitiesPage">
                    {{ $t("SignUpForm.add_to_other_establishments") }}
                  </button>
                </div>
              </form>
            </transition>
            <!-- End of form -->
          </div>

          <footer-confirmation-page v-if="isSubmitted" />
        </div>

        <div v-else class="card border-0 mb-0 p-0">
          <sign-up-form-entities
            :entityCode="validEntityCode"
            :occupations="user.occupations"
            :email="user.email"
            @signUp="signUp"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { formatNumber, parseNumber } from 'libphonenumber-js'
  import SignUpFormEntities from './SignUpFormEntities'
  import FooterConfirmationPage from './FooterConfirmationPage'
  import ProfessionForm from '@/components/candidate/ProfessionForm'
  import { filterEmail } from '@/helpers/email'
  import TermsAndConditions from './candidate/TermsAndConditions.vue'

  export default {
    name: 'SignUpForm',
    components: {
      SignUpFormEntities,
      FooterConfirmationPage,
      ProfessionForm,
      TermsAndConditions
    },
    data: function () {
      return ({
        password_confirmation: '',
        entityCode: '',
        validEntityCode: null,
        isSubmitted: false,
        isUserExists: false,
        isPending: false,
        isSended: false,
        isEntitiesPage: false,
        specialCharError: false,
      });
    },
    computed: {
      ...mapGetters({
        user: 'users/user',
        serverErrors: 'users/errors',
        hasErrors: 'users/hasErrors',
        email: 'users/email',
        hubsOptions: 'users/manageableHubs',
        servicesOptions: 'users/manageableServices',
        occupationsOptions: 'users/manageableOccupations',
        entityCodeValidity: 'users/entityCodeValidity',
        entity: 'users/entity',
        addOns: 'users/addOns',
        isSingleEntity: 'users/isSingleEntity',
        mailCheckedEmail: 'users/emailSuggestion'
      }),
      maxEntityCodeSize () {
        return 5
      },
      minEntityCodeSize () {
        return 4
      },
      currentEntity(){
        return this.entity
      },
      isInternal(){
        return this.user.resource_type == 'intern'
      },
      showEntities() {
        return this.entity && !this.isSingleEntity
      },
      userToAddon() {
        return {
          entity_id: this.entity.id,
          entity: this.entity,
          resource_type: this.user.resource_type,
          affiliated_service: this.user.affiliated_service,
          services: this.user.services,
          occupations: this.user.occupations,
          unavailability_dates_provider_id: this.user.unavailability_dates_provider_id
        }
      }
    },
    watch: {
      entityCode: function () {
        this.user.affiliated_service = null
        this.user.occupations = []
        this.user.services = []
        this.user.unavailability_dates_provider_id = null
        if (this.entityCode.length == this.maxEntityCodeSize || this.entityCode.length == this.minEntityCodeSize) {
          this.validEntityCode = this.entityCode
          this.updateManageableOptions({ entityCode: this.entityCode })
        } else {
          this.updateEntityCodeValidity(false)
        }
      },
      email: function () {
        this.removeErrors()
      },
    },
    methods: {
      ...mapActions({
        updateManageableOptions: 'users/updateManageableOptions',
        updateEntityCodeValidity: 'users/updateEntityCodeValidity',
        removeErrors: 'users/removeErrors',
        createPublicly: 'users/createPublicly',
        usersSendMailCandidate: 'users/sendMailCandidate',
        usersValidateStatusEmail: 'users/validateStatusEmail',
        verifyEmail: 'users/verifyEmail',
        resetMailSuggestion: 'users/resetMailSuggestion'
      }),
      handleEmailInput(event) {
      const isValid = filterEmail(event.target.value);
      this.specialCharError = !isValid;
    },
      onProfessionFormChange(value) {
        this.user.resource_type = value.resource_type
        this.user.affiliated_service = value.affiliated_service
        this.user.services = value.services
        this.user.occupations = value.occupations
        this.user.unavailability_dates_provider_id = value.unavailability_dates_provider_id
      },
      signUp() {
        var self = this;
        this.$validator.validateAll().then((result) => {
          if (self.isUserExists) {
            $('.signin-form').scrollTop(0)
          }
          if (self.specialCharError) {
            return;
          } else {
              self.specialCharError = false;
          }
          if (result && !self.hasErrors && !self.isUserExists) {
            this.user.phone = formatNumber(parseNumber(this.user.phone_display, 'FR'), 'E.164')
            this.user.entity_id = this.entity.id
            this.user.add_ons = this.addOns.filter(addOn => addOn.selected)
            this.createPublicly(this.user).then(() => {
              if (!this.hasErrors) {
                this.isSubmitted = true
                this.isEntitiesPage = false
              }
            })
          }
        });
      },
      prefillEntityCode(entityCode) {
        if(entityCode){
          this.entityCode = entityCode;
        }
      },
      sendMailCandidate() {
        if (this.email) {
          this.usersSendMailCandidate(this.email)
          this.isSended = true
        }
      },
      validateStatusEmail: function () {
        if (this.email) {
          this.usersValidateStatusEmail(this.email)
          .then((response) => {
            if (response) {
              this.isUserExists = true
              this.isPending = response.is_pending
              $('.signin-form').scrollTop(0)
            } else {
              this.isUserExists = false
              this.isPending = false
            }
          })

          this.verifyEmail(this.email)
        } else {
          this.isUserExists = false
          this.isPending = false
          $('.signin-form').scrollTop(0)
        }
      },
      setEmail() {
        this.user.email = this.mailCheckedEmail
        this.resetMailSuggestion()
      },
      showEntitiesPage() {
        this.$validator.validateAll().then((result) => {
          if(result) {
            this.isEntitiesPage = true
          }
        })
      },
    },
    mounted: function () {
      window.Pages && window.Pages.initSelectFxPlugin(); // init Select dropdown handler
      if (this.$route) {
        this.prefillEntityCode(this.$route.params.entityCode);
      }
    }
  }
</script>


<style lang="scss" scoped>
  .form--suggestEmail {
    background-color: #F2F2F2;
    color: #6D7173;
    border-radius: 7px;
    padding: 7px;
    text-align: center;
    font-size: 10px;
    letter-spacing: 0.1rem;
    margin-bottom: 15px;
  }
  .email-suggestion {
    color: #e51349;
    cursor: pointer;
    text-decoration: underline;
  }
  .accept-cgu {
    a {
      text-decoration: underline;
    }

    label::before {
      left: 2px;
    }
  }

  .add-establishment-btn {
    background: #e51349;
    color: white;
    // margin-bottom: 20px;
    &:hover {
      background: #e51349;
      color: white;
    }
  }

  .bg {
    background-color: #fff;
  }
  .overflow-scroll {
    overflow: auto;
  }
  .login {
    height: 100vh;
  }
  .card {
    padding: 1rem 1rem 1rem;
  }
  .card-header p {
    text-align: right;
    font-size: 12px;
  }
  .box-message-pending {
    background: #E5F4F5;
    padding: 8px;
    margin-bottom: 15px;
  }
  .box-message-pending a {
    color: #159f92;
  }
  /* Overhide default bootstrap style of .card-header a */
  .card-header a:not(.btn) {
    color: #e51349 !important;
    opacity: 1 !important;
  }
  .card-header a:hover {
    filter: brightness(70%);
  }
  .btn {
    white-space:normal;
    word-wrap: break-word;
  }

  @media (max-width: 767px) {
    .card {
      min-height: 100vh;
    }
    .logo-style {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .card-footer {
      position:absolute;
      bottom:0;
      align-self: center;
    }
    .card-body {
      padding: 15px;
    }
    .smartphone-img {
      display: none;
    }

    .marge-mobile{
      margin-bottom: 100px;
    }
  }

  @media (min-width: 768px) {
    .card {
      padding: 2rem 4rem 2rem;
      border-radius: 15px;
      max-width: 600px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    .card-header {
      padding-right: 0px;
    }
    .bg {
      background: url('/static/img/signin_form.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
    }
    .logo-style {
      position: fixed;
      top: 20px;
      left: 20px;
      margin: 0px;
      width: 350px;
      height: auto;
    }
    .smartphone-img {
      position: fixed;
      bottom: -15px;
      right: -15px;
    }
    .smartphone-img > img {
      height: 450px;
      width: auto;
    }
  }

  @media (min-width: 768px) and (max-width: 1400px) and (orientation: portrait) {
    .logo-style {
      position: fixed;
      top: 20px;
      left: 50%;
      margin: 0px;
      align-content: center;
      transform: translate(-50%);
    }
    .smartphone-img {
      display: none;
    }
  }

  /* avoids logo overlap when tablet is used in landscape orientation */
  @media (min-width: 768px) and (max-width: 1400px) and (orientation: landscape) {
    .logo-style {
      position: static;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .smartphone-img {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SignUpForm.vue